import React, {FC} from 'react';
import { Button, Input, Modal, Pagination, Select,SidebarLayout, Header, Icon, BadgedIcon,TextArea } from '@scuf/common';
import { PropertiesPlugin } from '@hcecbp/webappanalytics';


export const StageTwo: FC<{header:string}> = ({header}) => {
 
  return (
    <div className='right-container'>
      <div className='right-container-step-one'>
        <div className='development-inprogress'>
          <Icon name="tools" className="add-icon"  size="xlarge" />
        </div>

  
  {/* <div className='right-container-step-one-footer'>
   <Button
                className='action-btn custom-btn'
                size='small'
                type='secondary'
                textTransform={false}
                content='Cancel'
                // onClick={() => handleClose()}
              />
              <Button
                className='action-btn custom-btn'
                size='small'
                textTransform={false}
                // disabled={disableButton || editLoading}
                // loading={editLoading}
                // onClick={() => onUpdate()}
                content='Update'
              />
              </div> */}
              </div>
  </div>
    
  );
};

export default StageTwo;